import { difference } from 'lodash';
import {
  USERROLEPERMISSIONS_SET,
  USERROLEPERMISSIONS_EDITED,
  USERROLEPERMISSIONS_ADDED,
  USERROLEPERMISSIONS_DELETED,
  USERLOCALPERMISSIONS_SET,
  USERALLDATABASESPERMISSIONS_SET,
} from 'src/app/redux/redux-types';
import { reduxUserRolePermissionsTypes } from 'src/types';

export const userRolePermissionsDefaultState: reduxUserRolePermissionsTypes.StateType = {
  userrolepermissions: [],
  localpermissions: [],
  alldatabasepermissions: [],
};

export const userRolePermissionReducer = (
  state = userRolePermissionsDefaultState,
  action: reduxUserRolePermissionsTypes.ActionType,
): reduxUserRolePermissionsTypes.StateType => {
  switch (action.type) {
    case USERLOCALPERMISSIONS_SET:
      return {
        ...state,
        localpermissions: action.payload,
      };
    case USERALLDATABASESPERMISSIONS_SET:
      return {
        ...state,
        alldatabasepermissions: action.payload,
      };
    case USERROLEPERMISSIONS_SET:
      return {
        ...state,
        userrolepermissions: action.payload,
      };
    case USERROLEPERMISSIONS_ADDED:
      // eslint-disable-next-line no-case-declarations
      const exists = state.userrolepermissions.some((item) => item.userRoleId === action.payload[0].userRoleId);
      if (exists) {
        return state;
      }
      return {
        ...state,
        userrolepermissions: [...action.payload, ...state.userrolepermissions],
      };
    case USERROLEPERMISSIONS_EDITED:
      // eslint-disable-next-line no-case-declarations
      const deleteIndexLength = state.userrolepermissions.filter(
        (obj) => obj.userRoleId === action.payload[0].userRoleId,
      );
      const reducedPayload =
        action.payload.length >= deleteIndexLength.length
          ? [...action.payload]
          : difference(action.payload, deleteIndexLength);
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.userrolepermissions.findIndex((obj) => obj.userRoleId === action.payload[0].userRoleId);

      return {
        ...state,
        userrolepermissions: [
          ...difference(state.userrolepermissions.slice(0, updateIndex), deleteIndexLength),
          ...reducedPayload,
          ...difference(state.userrolepermissions.slice(updateIndex + 1), deleteIndexLength),
        ],
      };
    case USERROLEPERMISSIONS_DELETED:
      return {
        ...state,
        userrolepermissions: state.userrolepermissions.filter((o) => o.userRoleId !== action.payload),
      };
    default:
      return state;
  }
};
